export default __webpack_public_path__ + "static/media/wallet-card-theme6.0ea345a0.svg";